export const redirect = (url: string) => {
  // we need to replace the location to prevent bug in firefox when user clicks back
  window.location.replace(url);
};
